import { useState, useEffect } from 'react'
import { HeaderHLPure, SimpleLoading } from '../../pures'
import {
    Container,
    Grid,
    TextField,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Paper,
    Box
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import IFrame from '../../pures/dashboard/iframe'
import { IconButton } from '@material-ui/core'
import { Cancel } from '../../../assets/logos/icons'

const containerImageCustomStyles = {
    margin: 'auto',
    width: '18px',
    height: '18px',
  }

const ChatsView = ({ chatbotUrl, isLoading = false, conversations = [], handleOnClickConversation, token, botId }) => {
    // #region variables
    const { t } = useTranslation('clients-dashboard', { keyPrefix: 'chatsScreen' })
    const [query, setQuery] = useState('')
    const [selectedId, setSelectedId] = useState(conversations.length ? conversations[0].conversationId : null)
    const selectedConversation = conversations.find(c => c.conversationId === selectedId) || null
    const [iframeUrl, setIframeUrl] = useState('')
    // #endregion variables

    // #region effects
    useEffect(() => {
      if (selectedId) {
        const url = `${chatbotUrl}?botId=${selectedConversation.botConfigId}&oldConversationId=${selectedConversation.conversationId}&clientToken=${token}`
        setIframeUrl(url)
      }
    }, [selectedId])

    useEffect(() => {
      setSelectedId(null)
    }, [botId])
    // #endregion effects

    // #region methods
    /**
     * @description event to convert date [YYYY-MM-DD HH:mm:ss] to get only hour
     * @param value date string with this format -> [YYYY-MM-DD HH:mm:ss]
     */
    const convertDateToHour = (value) => {
      let {hours, minutes, period} = ''
      try {
        if (value) {
          const arrayDate = value.split(' ')
          const arrayDateTime = arrayDate[1].split(':')
          hours = arrayDateTime[0]
          minutes = arrayDateTime[1]
          period = Number(hours) >= 13 ? 'PM' : 'AM'
        }
      } catch (error) {
        console.log(`An error ocurred in convertDateToHour: ${error}`)
      } finally {
        return (hours && minutes) ? `${hours}:${minutes} ${period}` : ''
      }
    }
    // #endregion methods

    if (isLoading) {
        return (
            <div className='loading'>
                <SimpleLoading />
            </div>
        )
    }

    return (
      <Container maxWidth='lg' style={{ paddingTop: 16 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <HeaderHLPure title={t('chats') || 'Chats'} />
          </Grid>

          <Grid item xs={12}>
            <Paper
              style={{ height: '75vh', display: 'flex', overflow: 'hidden', boxShadow: '0px 4px 8px rgba(8, 8, 8, 0.15)' }}
            >
              {/* Sidebar: conversations */}
              <Box
                width='320px'
                borderRight='1px solid rgba(0,0,0,0.08)'
                display='flex'
                flexDirection='column'
              >
                <Box p={1} display='flex' alignItems='center'>
                  <TextField
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder={t('search') || 'Buscar o empezar nuevo chat'}
                    variant='outlined'
                    size='small'
                    fullWidth
                    InputProps={{
                      endAdornment: query && (
                        <IconButton
                          size='small'
                          onClick={() => setQuery('')}
                          style={{ padding: 4 }}
                        >
                          <img
                            src={Cancel}
                            alt=''
                            style={containerImageCustomStyles}
                          />
                        </IconButton>
                      ),
                    }}
                  />
                </Box>

                <Box flex='1' style={{ overflowY: 'auto' }}>
                  <List disablePadding>
                    {conversations
                      .filter((conv) =>
                        conv.conversationId?.toLowerCase().includes(query.toLowerCase())
                      )
                      .map((conv) => (
                        <ListItem
                          button
                          key={conv.conversationId}
                          selected={conv.conversationId === selectedId}
                          onClick={() => {
                            setSelectedId(conv.conversationId)
                            handleOnClickConversation(conv.conversationId)
                          }}
                        >
                          <ListItemAvatar>
                            <div
                              style={{
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                backgroundColor: '#f0f0f0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                color: '#666',
                                backgroundImage:
                                  'url(https://www.transparentpng.com/download/user/gray-user-profile-icon-png-fP8Q1P.png)',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                              }}
                              className={`${!conv.finished && 'borderActiveChat'}`}
                            >
                            </div>
                            {
                              conv.mode === 'realTime' &&
                              <div className='iconChat'>
                                <i className="k-icon k-icon-sm k-i-play"></i>
                              </div>
                            }
                          </ListItemAvatar>
                          <ListItemText
                            className='chatText'
                            primary={
                              <span className='chatTitle'>
                                <span style={{ fontSize: '14px' }}>
                                  {conv.userData.email ||
                                    conv.userData.phone ||
                                    conv.userData.ip && t('guest') ||
                                    t('guest')}
                                </span>
                                <span className='chatHour'>
                                  {convertDateToHour(conv.updatedDate) || ''}
                                </span>
                              </span>
                            }
                            secondary={conv.conversationId && conv.conversationId.substring(conv.conversationId.length, conv.conversationId.length - 5) || ''}
                          />
                        </ListItem>
                      ))}
                  </List>
                </Box>
              </Box>

              {/* Chat area */}
              {selectedId ? (
                <div className={'containerIframe'}>
                  <IFrame
                    height='100%'
                    width='100%'
                    url={iframeUrl}
                  />
                </div>
              ) : <div className={'containerNoIframe'}>
                  <p className='containerNoIframe-text'>{t('noSelectedChat')}</p>
                </div>}
            </Paper>
          </Grid>
        </Grid>
      </Container>
    )
}

export default ChatsView